import { z } from 'zod'

export const DashboardAccessEventSchema = z.object({
  Nome: z.string(),
  Email: z.string(),
})

export const DashboardSelectCourseSchema = z.object({
  Nome: z.string(),
  Email: z.string(),
  CursoID: z.string(),
  CursoNome: z.string(),
})

export const DashboardStudyGoalChangeSchema = z.object({
  Nome: z.string(),
  Email: z.string(),
  CursoID: z.string(),
  CursoNome: z.string(),
  Meta: z.number(),
})

export const IdentifyUserEventSchema = z.object({
  Nome: z.string(),
  Email: z.string(),
  Id: z.string(),
  Produto: z.string().optional(),
  Produtos: z.string().array().optional(),
  Plano: z.enum(['Gratuito', 'Assinatura', 'Curso', 'Módulo']).optional(),
})

export const DownloadContentSchema = z.object({
  Curso: z.string(),
  Carreira: z.string(),
  Instituicao: z.string(),
  Modulo: z.string(),
  Aula: z.string(),
  Capitulo: z.string(),
  Objeto: z.string(),
  Formato: z.enum(['Texto', 'Vídeo']),
  Tipo: z.enum(['Completo', 'Individual']),
  Atual: z.number(),
  Inicio: z.boolean(),
  Fim: z.boolean(),
})

export const AccessContentSchema = z.object({
  Carreira: z.string(),
  Instituicao: z.string(),
  Curso: z.string(),
  Modulo: z.string(),
  Aula: z.string(),
  Capitulo: z.string(),
  Formato: z.enum(['Excerto', 'Vídeo']),
  Modo: z.enum(['Começar', 'Continuar']),
  Total: z.number(),
  Atual: z.number(),
  Porcentagem: z.number(),
  Inicio: z.boolean(),
  Meio: z.boolean(),
  Fim: z.boolean(),
  Origem: z.enum(['Módulo', 'Sessão de Estudo', 'Edital Verticalizado']),
})

export const ContentSchema = z.object({
  Carreira: z.string(),
  Instituicao: z.string(),
  Curso: z.string(),
  Modulo: z.string(),
  Aula: z.string(),
  Capitulo: z.string(),
  Object: z.string().optional(),
  Formato: z.enum(['Texto', 'Vídeo']),
})

export const MessageListPageAccessSchema = z.object({
  CursoNome: z.string(),
  Modulo: z.string(),
  Professor: z.string(),
  Origem: z.union([
    z.literal('Pagina de Recados'),
    z.literal('Aba de Notificacao'),
    z.literal('Outro'),
  ]),
})

export const CourseSchema = z.object({
  Curso: z.string().min(3),
  Instituicao: z.string().optional(),
  Carreira: z.string().min(3),
})

const QuestionFilters = {
  Texto: z.string().optional(),
  Disciplinas: z.number(),
  Disciplina_1: z.string().optional(),
  Assuntos: z.number(),
  Assunto_1: z.string().optional(),
  Topicos: z.number(),
  Topico_1: z.string().optional(),
  Cargos: z.number(),
  Cargo_1: z.string().optional(),
  Formacoes: z.number(),
  Formacao_1: z.string().optional(),
  Escolaridades: z.number(),
  Escolaridade_1: z.string().optional(),
  Anos: z.number(),
  Ano_1: z.number().optional(),
  Bancas: z.number(),
  Banca_1: z.string().optional(),
  Orgaos: z.number(),
  Orgao_1: z.string().optional(),
  Minhas_Questoes: z
    .enum(['Corretas', 'Erradas', 'Corretas ou Erradas', 'Erradas ou Corretas', 'Não respondidas'])
    .optional(),
  Tipo_Questao_1: z
    .enum([
      'Certo ou errado',
      'Múltipla escolha - 4 alternativas',
      'Múltipla escolha - 5 alternativas',
    ])
    .optional(),
  Tipos_Questoes: z.number(),
  Anuladas: z.boolean().optional(),
  Avancado: z.boolean().optional(),
  Filtros: z.number(),
}

export const QuestionFilterSchema = z.object({
  ...QuestionFilters,
})

export const QuestionBookSchema = z.object({
  ...QuestionFilters,
  Questoes_Encontradas: z.number(),
  Questoes_Caderno: z.number(),
  Status: z.enum(['Sucesso', 'Falha']),
  Caderno_Nome: z.string().optional(),
  Caderno_Id: z.string().optional(),
})

export const QuestionAnswerSchema = z.object({
  Disciplina_1: z.string().optional(),
  Assunto_1: z.string().optional(),
  Topico_1: z.string().optional(),
  Cargo_1: z.string().optional(),
  Formacao_1: z.string().optional(),
  Escolaridade: z.string().optional(),
  Ano: z.number().optional(),
  Banca: z.string().optional(),
  Orgao: z.string().optional(),
  Questao: z.string().optional(),
  Tipo_Questao: z.enum([
    'Certo ou errado',
    'Múltipla escolha - 4 alternativas',
    'Múltipla escolha - 5 alternativas',
  ]),
  Origem: z.enum(['Listagem', 'Caderno']),
  Resposta: z.enum(['A', 'B', 'C', 'D', 'E', 'F']),
  Acertou: z.boolean(),
})

export const BannerSchema = z.object({
  Nome: z.string().min(3),
})

export const TourEventSchema = z.object({
  tour_type: z.enum(['wizard', 'dashboard', 'plan', 'timer', 'session']),
  tour_action: z.enum([
    'shown',
    'skipped',
    'step_completed',
    'created',
    'started_first_time',
    'completed_first_time',
  ]),
  tour_step: z.number().optional(),
})

export const verifySchema = <T>(schema: z.ZodObject<any>, properties: T, eventName?: string) => {
  try {
    schema.parse(properties)
    return true
  } catch (err) {
    console.log(eventName, err, properties)
    return false
  }
}
